<div class="il-page animate-fade-in">
  <header class="il-header">
    <div class="il-header__title">
      <svg class="il-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
      </svg>
      <div>
        <h1 class="il-header__headline">Image Library</h1>
        <p class="il-header__sub">{{ images().length }} image{{ images().length === 1 ? '' : 's' }}</p>
      </div>
    </div>
  </header>

  @if (errorMsg()) {
    <div class="il-alert" role="alert">
      <span>{{ errorMsg() }}</span>
      <button class="il-alert__close" (click)="errorMsg.set(null)" aria-label="Dismiss error">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
  }

  @if (isLoading() && images().length === 0) {
    <div class="il-state">Loading…</div>
  } @else if (images().length === 0) {
    <div class="il-state il-state--col">
      <p class="il-empty-title">No images yet</p>
      <p class="il-empty-sub">Images you generate will show up here.</p>
    </div>
  } @else {
    <div class="il-grid">
      @for (img of images(); track img.generation_id) {
        <article class="il-card">
          <a class="il-card__link" [href]="img.image_url" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'Open image: ' + img.prompt">
            <span class="il-card__imgwrap">
              <img class="il-card__img" [src]="img.image_url" [alt]="img.prompt" loading="lazy"/>
            </span>
            <span class="il-card__body">
              <span class="il-card__prompt">{{ img.prompt }}</span>
              <span class="il-card__date">{{ img.created_at | date:'MMM d, y, HH:mm' }}</span>
            </span>
          </a>
          <button type="button" class="il-card__delete"
            [disabled]="!!img.in_use || deletingId() === img.generation_id"
            [attr.aria-label]="img.in_use ? 'Used by content, cannot delete' : 'Delete image'"
            [title]="img.in_use ? 'Used by a content' : 'Delete'"
            (click)="askDelete(img)">
            @if (img.in_use) {
              <span class="il-card__used">In use</span>
            } @else {
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
              </svg>
            }
          </button>
        </article>
      }
    </div>
  }
</div>

@if (pendingDelete(); as image) {
  <div class="il-modal-backdrop" [class.il-modal-backdrop--closing]="deleteClosing()" role="dialog" aria-modal="true" aria-labelledby="il-delete-title" (click)="closeDelete()">
    <div class="il-modal" [class.il-modal--closing]="deleteClosing()" (click)="$event.stopPropagation()">
      <h3 id="il-delete-title" class="il-modal__title">Delete image</h3>
      <p class="il-modal__text">Delete <strong>{{ image.prompt }}</strong>? This cannot be undone.</p>
      <div class="il-modal__actions">
        <button type="button" class="il-btn" (click)="closeDelete()" [disabled]="!!deletingId()">Cancel</button>
        <button type="button" class="il-btn il-btn--danger" (click)="confirmDelete()" [disabled]="!!deletingId()">
          {{ deletingId() ? 'Deleting…' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
}
